import { Archive } from '@interhyp/module-credit';
import { GlobalNotificationBanner } from '@interhyp/shared-credit';
import React, { useMemo } from 'react';
import { useLocation } from 'react-use';

import '@interhyp/shared-credit/esm/index.css';
import '@interhyp/module-credit/esm/index.css';

import { Navigation, NavItems } from '../../navigation/Navigation';

export interface ArchiveWrapperProps {
  currentUserId: string;
  providerId: string;
}

export function ArchiveWrapper({ currentUserId, providerId }: ArchiveWrapperProps): JSX.Element {
  const { search } = useLocation();
  const searchTerm = new URLSearchParams(search).get('search');

  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/dashboard/`, translation: 'navigation.pipeline' },
      { to: `/archive`, translation: 'navigation.archive' },
    ];
  }, []);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <GlobalNotificationBanner />
      <Archive
        currentUserId={currentUserId}
        providerId={providerId}
        searchTerm={searchTerm ?? undefined}
      />
    </>
  );
}
